// extracted by mini-css-extract-plugin
module.exports = {"sponsors":"SponsorSection_sponsors__n9jhz","sponsor":"SponsorSection_sponsor__3ErOG","logos":"SponsorSection_logos__1J7Y5"};